import React from "react";
import Zoom from "react-reveal/Zoom";
//images
import complete from "../../../../../assets/images/redesign/signup-react/complete-profile.png";
import eva from "../../../../../assets/images/redesign/signup-react/claim-samples.png";
import gift from "../../../../../assets/images/redesign/signup-react/gift.png";
import money from "../../../../../assets/images/redesign/signup-react/money-small.png";
import star from "../../../../../assets/images/redesign/signup-react/star.png";
import like from "../../../../../assets/images/redesign/signup-react/share-feedback.png";
import rewards from "../../../../../assets/images/redesign/signup-react/get-rewarded.png";
import check from "../../../../../assets/images/redesign/signup-react/check.png";

function HowItWorks() {
  return (
    <div className="pw-works-container">
      <div className="pw-container">
        <h1 className="pw-works-container--title">How it works</h1>
      </div>
      <div className="pw-container pw-works-container--inner">
        <div className="pw-row">
          <Zoom>
            <div className="pw-col-4">
              <div className="pw-works-container--image-block">
                <div className="pw-works-container--image-block__inner">
                  <img src={complete} alt="" className={"primary-image"} />
                </div>
              </div>
              <div className="pw-works-container--text-container">
                <span className="pw-works-container--block-title">1</span>
                <p className="pw-works-container--block-subtitle">
                  Complete your <br className="pw-d-none" /> profile
                </p>
              </div>
            </div>
          </Zoom>

          <Zoom>
            <div className="pw-col-4">
              <div className="pw-works-container--image-block">
                <div className="pw-works-container--image-block__inner">
                  <img src={eva} alt="" className={"primary-image"} />
                </div>
              </div>
              <div className="pw-works-container--text-container">
                <span className="pw-works-container--block-title">2</span>
                <p className="pw-works-container--block-subtitle">
                  Claim samples <br className="pw-d-none" /> each month
                </p>
              </div>
            </div>
          </Zoom>

          <Zoom>
            <div className="pw-col-4">
              <div className="pw-works-container--image-block">
                <div className="pw-works-container--image-block__inner">
                  <img src={like} alt="" className={"primary-image"} />
                </div>
              </div>
              <div className="pw-works-container--text-container">
                <span className="pw-works-container--block-title">3</span>
                <p className="pw-works-container--block-subtitle">
                  Share <br className="pw-d-none" /> feedback
                </p>
              </div>
            </div>
          </Zoom>

          <Zoom>
            <div className="pw-col-4">
              <div className="pw-works-container--image-block">
                <div className="pw-works-container--image-block__inner">
                  <img src={rewards} alt="" className={"primary-image"} />
                </div>
              </div>
              <div className="pw-works-container--text-container">
                <span className="pw-works-container--block-title">4</span>
                <p className="pw-works-container--block-subtitle">
                  Earn PINCHme coins
                  <br className="pw-d-none" /> & get rewarded
                </p>
              </div>
            </div>
          </Zoom>
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
